import { render, staticRenderFns } from "./LoyaltyLevel.vue?vue&type=template&id=1939df52"
import script from "./LoyaltyLevel.vue?vue&type=script&lang=js"
export * from "./LoyaltyLevel.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyLevel.vue?vue&type=style&index=0&id=1939df52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports